



































import { Component, Vue } from "vue-property-decorator";
import { getPost, copyPost } from "@/services/posts/postsService";
import { Post, CopyPost } from "@/services/posts/types";

@Component
export default class PostCopyModal extends Vue {
    item = {} as Post;
    model = {} as CopyPost;

    open(postId: string) {
        getPost(postId).then(response => {
            this.item = response;
            this.model.postId = postId;
            this.model.name = this.item.name + " Copy";
            this.$bvModal.show("modal-postCopy");
        });
    }

    confirm() {
        this.$bvModal.hide("modal-postCopy");
        copyPost(this.model).then(() => {
            this.$emit("reload");
        });
        this.model = {} as CopyPost;
    }

    decline() {
        this.$bvModal.hide("modal-postCopy");
    }
}
